import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";

export const SortedListLoading = ({ columnCount, numberOfRows }) => {
  return _.times(numberOfRows, i => (
    <div key={i} className="sorted-list__row --loading">
      {_.times(columnCount, index => (
        <div key={index} className="sorted-list__data">
          <div className="--loading-bar" />
        </div>
      ))}
    </div>
  ));
};

SortedListLoading.propTypes = {
  columnCount: PropTypes.number,
  numberOfRows: PropTypes.number
};

SortedListLoading.defaultProps = {
  columnCount: 4,
  numberOfRows: 5
};



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/SortedListLoading.js